import { Chip } from "@mui/material"
import { Box } from "@mui/system"
import { FC } from "react"
import { ELEMENT_RADIUS_MID } from "utils/customizedTheme"

interface IProps {
  fromPicker: JSX.Element
  toPicker: JSX.Element 
  icon: JSX.Element 
  label: string
}

const DataRangePicker: FC<IProps> = ({fromPicker, toPicker, icon, label}) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: '2.5rem', width: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <Chip
          avatar={icon}
          color='default'
          label={label}
          sx={{
            fontSize: '1rem',
            marginBottom: '1rem',
            borderRadius: ELEMENT_RADIUS_MID,
            padding: '1.1rem 0.3rem',
          }}
        />
      </Box>

      <Box sx={{ width: { xs: '100%', md: '45%' }, flex: '1 1 auto', marginBottom: '1rem'}} >
        {fromPicker}
      </Box>
      <Box sx={{ width: { xs: '100%', md: '45%' }, flex: '1 1 auto', marginBottom: '1rem'}}>
        {toPicker}
      </Box>
    </Box>
  )
}
export default DataRangePicker
